import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/settings';
  static paymentMethodsInfo = `${this.baseUrl}/payment-methods/info`;

  static async getPaymentMethodsInfoSelects() {
    const url = `${this.paymentMethodsInfo}/selects`;
    return await fetchWrapper.get(url);
  }

  static async getPaymentMethodsInfo(filters) {
    const url = `${this.paymentMethodsInfo}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async createPaymentMethodsInfo(form) {
    return await fetchWrapper.post(this.paymentMethodsInfo, form);
  }

  static async updatePaymentMethodInfo(form) {
    return await fetchWrapper.put(this.paymentMethodsInfo, form);
  }

  static async removePaymentMethodInfo(form) {
    return await fetchWrapper.delete(this.paymentMethodsInfo, form);
  }
}

export class school {
  static baseUrl = process.env.REACT_APP_BASE_API + 'school/settings';
  static schoolYears = `${this.baseUrl}/school-years`;
  static quantifications = `${this.baseUrl}/quantifications`;
  static qualifications = `${this.baseUrl}/qualifications`;
  static indicators = `${this.baseUrl}/indicators`;

  static async createSchoolYear(form) {
    return await fetchWrapper.post(this.schoolYears, form);
  }

  static async getSchoolYears(filters) {
    const url = `${this.schoolYears}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async updateSchoolYear(form) {
    return await fetchWrapper.put(this.schoolYears, form);
  }

  static async destroySchoolYear(form) {
    return await fetchWrapper.delete(this.schoolYears, form);
  }

  static async getQuantifications(filters) {
    const url = `${this.quantifications}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveQuantifications(form) {
    return await fetchWrapper.post(this.quantifications, form);
  }

  static async getQualifications(filters) {
    const url = `${this.qualifications}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveQualifications(form) {
    return await fetchWrapper.post(this.qualifications, form);
  }

  static async getIndicators(filters) {
    const url = `${this.indicators}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveIndicators(form) {
    return await fetchWrapper.post(this.indicators, form);
  }

  static async removeIndicator(form) {
    return await fetchWrapper.delete(this.indicators, form);
  }
}

export class teacher {
  static baseUrl = process.env.REACT_APP_BASE_API + 'teacher/settings';
  static schoolYears = `${this.baseUrl}/school-years`;
  static quantifications = `${this.baseUrl}/quantifications`;
  static qualifications = `${this.baseUrl}/qualifications`;
  static indicators = `${this.baseUrl}/indicators`;

  static async createSchoolYear(form) {
    return await fetchWrapper.post(this.schoolYears, form);
  }

  static async getSchoolYears(filters) {
    const url = `${this.schoolYears}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async updateSchoolYear(form) {
    return await fetchWrapper.put(this.schoolYears, form);
  }

  static async destroySchoolYear(form) {
    return await fetchWrapper.delete(this.schoolYears, form);
  }

  static async getQuantifications(filters) {
    const url = `${this.quantifications}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveQuantifications(form) {
    return await fetchWrapper.post(this.quantifications, form);
  }

  static async getQualifications(filters) {
    const url = `${this.qualifications}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveQualifications(form) {
    return await fetchWrapper.post(this.qualifications, form);
  }

  static async getIndicators(filters) {
    const url = `${this.indicators}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async saveIndicators(form) {
    return await fetchWrapper.post(this.indicators, form);
  }

  static async removeIndicator(form) {
    return await fetchWrapper.delete(this.indicators, form);
  }
}